// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.


export const environment = {
    //! ===================================== BASE ENV =========================================================
    START_YEAR: 2020,
    TIME_SESSION: 18, // espressa in minuti e indica il tempo per avviso di sessione che sta per scadere
    //PRECISION: '#,##0.00',//',##0.000',
    PRECISION: '########0.###',
    PRECISION_VIRGOLA: '#,##0.###',
    MAX_VALUE_PESO: '99999.999', // espressa in KG
    MIN_VALUE_PESO: '1.000', // espressa in KG

    ALL_CHARACTERS: '/[a-zA-Z0-9,.\\-+èù*\\\/()$%&?:;_#{}@àù<>ì&^ ]/',
    GENERIC_STRING: '/[a-zA-Z0-9,.\\-+*\\\/()$%&?:;_#{}@<>& ]/',
    ONLY_NUMBER_CHARACTERS: '/[0-9]/',
    ONLY_NUMBER_CHARACTERS_VIRGOLE_PUNTI: '/[0-9.,]/',
    ONLY_CHARACTERS: '/[a-zA-z0-9 ]/',
    CHARACTERS_DATE: '/[0-9\\\/]/',
    CHARACTERS_NUMBER_INPUT: '/[0-9]/',
    TELEPHONE: "^((\\+39|0039)?[\\s\\-]?)?(3\\d{2}[\\s\\-]?\\d{3}[\\s\\-]?\\d{3}|0\\d{1,3}[\\s\\-]?\\d{6,7})$",

    WS_ENDPOINT_3CX: 'wss://webrtc.hichat.it:9001', //certificato scade il 9 luglio

    LINK_PRIVACY_POLICY: 'https://rentrincloud.it/privacy.html',
    LINK_COOCKIE_POLICY: 'https://rentrincloud.it/cookies.html',
    LINK_ACCESSIBILITA_POLICY: 'https://rentrincloud.it/accessibilita.html',

    //dati relativi all'invio del contratto tramite SignBook
    enable: true,
    m_UserName: "",
    m_Password: "",
    m_Company: "",
    codfisc_op: "",
    nome_op: "",
    cognome_op: "",
    email_op: "",
    codfisc_fir2: "",
    nome_fir2: "",
    cognome_fir2: "",
    email_fir2: "",
    cell_fir2: "",
    //! =================================== TEST ENV ===========================================
    // production: false,
    // VERSIONE: '1.0.5',
    // BASE_API_URL_WEBRIFIUTI: 'https://www.webrifiuti.it/api/',
    // BASE_API_URL_APIREST: 'https://www.rentri.website/apirest/',
    // // BASE_API_URL_APIREST: 'https://rentrincloud.it/api/crmcontatti/',
    // END_POINT_RENTRI: 'https://demoapi.rentri.gov.it/',
    // END_POINT_VIVIFIR: 'https://demovivifir.ecocamere.it/',
    // END_POINT_DHWASTE: 'https://digitalhub.zucchettitest.it/fatelw/services/fatelwV2',
    // END_POINT_AI: 'https://806vwqn5-3333.euw.devtunnels.ms/',
    // SWAGGER: 'https://test.rentrincloud.it/api/swagger/index.html',
    // //BASE_API_URL_APIREST:'localhost:80/',
    // SHOW_RENTRI: false,
    // SOCKET_ENDPOINT_RICICLATV: 'https://socket.hichat.it:8500/?token=',
    // SOCKET_TOKEN_RICICLATV: '',
    // BANNER_IMAGE_URL_RICICLATV: 'https://www.ricicla.tv/dev/laravel_app/storage/app/images/riciclatv/banner_bottom/',
    // LINK_HOME_PAGE: 'https://www.winwaste.net/ww',
    // EMAIL_AMMINISTRAZIONE: 'amministrazione@crmcontatti.it',

    // BASE_API_URL: 'https://test.rentrincloud.it/api/', //'https://test.rentrincloud.it/api/',
    // BASE_URL_HELP: 'https://test.rentrincloud.it/dochelp/',
    // BASE_PUBLIC_IMAGE: 'https://test.rentrincloud.it/api/public/imguser/',

    //! =================================== DEMO ENV ===========================================
    // production: true,
    // VERSIONE: '1.0.5',
    // BASE_API_URL_WEBRIFIUTI: 'https://www.webrifiuti.it/api/',
    // BASE_API_URL_APIREST: 'https://www.rentri.website/apirest/',
    // // BASE_API_URL_APIREST: 'https://rentrincloud.it/api/crmcontatti/',
    // END_POINT_RENTRI: 'https://demoapi.rentri.gov.it/',
    // END_POINT_VIVIFIR: 'https://demovivifir.ecocamere.it/',
    // END_POINT_DHWASTE: 'https://digitalhub.zucchettitest.it/fatelw/services/fatelwV2',
    // END_POINT_AI: 'https://806vwqn5-3333.euw.devtunnels.ms/',
    // SWAGGER: 'https://demo.rentrincloud.it/api/swagger/index.html',
    // //BASE_API_URL_APIREST:'localhost:80/',
    // SHOW_RENTRI: false,
    // SOCKET_ENDPOINT_RICICLATV: 'https://socket.hichat.it:8500/?token=',
    // SOCKET_TOKEN_RICICLATV: '',
    // BANNER_IMAGE_URL_RICICLATV: 'https://www.ricicla.tv/dev/laravel_app/storage/app/images/riciclatv/banner_bottom/',
    // LINK_HOME_PAGE: 'https://www.winwaste.net/ww',
    // EMAIL_AMMINISTRAZIONE: 'amministrazione@crmcontatti.it',


    // BASE_API_URL: 'https://demo.rentrincloud.it/api/',
    // BASE_URL_HELP: 'https://demo.rentrincloud.it/dochelp/',
    // BASE_PUBLIC_IMAGE: 'https://demo.rentrincloud.it/api/public/imguser/',

    //! =================================== PROD ENV ===========================================

    production: true,
    VERSIONE: '1.0.5',
    BANNER_IMAGE_URL_RICICLATV: 'https://www.ricicla.tv/dev/laravel_app/storage/app/images/riciclatv/banner_bottom/',
    BASE_API_URL_WEBRIFIUTI: 'https://www.webrifiuti.it/api/',
    // BASE_API_URL_APIREST: 'https://www.rentri.website/apirest/',
    // BASE_API_URL_APIREST: 'https://rentrincloud.it/api/crmcontatti/',
    BASE_API_URL_APIREST: 'https://www.rentri.website/apirestprod/',
    SHOW_RENTRI: false,
    SWAGGER: 'https://test.rentrincloud.it/api/swagger/index.html',
    SOCKET_ENDPOINT_RICICLATV: 'https://socket.hichat.it:8500/?token=',
    SOCKET_TOKEN_RICICLATV: '',
    LINK_HOME_PAGE: 'https://www.winwaste.net/ww',
    EMAIL_AMMINISTRAZIONE: 'amministrazione@crmcontatti.it',
    END_POINT_RENTRI: 'https://api.rentri.gov.it/',
    END_POINT_DHWASTE: 'https://digitalhub.zucchetti.it/fatelw/services/fatelwV2',
    END_POINT_VIVIFIR: 'https://vivifir.ecocamere.it/',
    END_POINT_AI: 'https://806vwqn5-3333.euw.devtunnels.ms/',
    BASE_API_URL: 'https://rentrincloud.it/api/',
    BASE_PUBLIC_IMAGE: "https://rentrincloud.it/api/public/imguser/",
    BASE_URL_HELP: 'https://rentrincloud.it/dochelp/',
    //! =================================== ZUCCHETTI HUB CONS ENV ===========================================

    // VERSIONE: '1.0.5',
    // END_POINT_RENTRI: 'https://demoapi.rentri.gov.it/',
    // END_POINT_VIVIFIR: 'https://demovivifir.ecocamere.it/',
    // END_POINT_DHWASTE: 'https://digitalhub.zucchettitest.it/fatelw/services/fatelwV2',
    // END_POINT_AI: '',
    // SWAGGER: 'https://test.rentrincloud.it/api/swagger/index.html',

    // EMAIL_AMMINISTRAZIONE: '',

    // production: true,
    // BASE_API_URL_WEBRIFIUTI: 'https://www.webrifiuti.it/api/',
    // BASE_API_URL_APIREST: 'https://www.rentri.website/apirest/',
    // SHOW_RENTRI: true,
    // SOCKET_ENDPOINT_RICICLATV: 'https://socket.hichat.it:8500',
    // SOCKET_TOKEN_RICICLATV: '',
    // BANNER_IMAGE_URL_RICICLATV: 'https://www.ricicla.tv/dev/laravel_app/storage/app/images/riciclatv/banner_bottom/',
    // LINK_HOME_PAGE: 'https://www.winwaste.net/ww',


    // BASE_API_URL: 'https://hub.rentrincloud.it/api/', //'http://rentrincloud.it:8080/api/',
    // BASE_URL_HELP: 'https://hub.rentrincloud.it/dochelp/',
    // BASE_PUBLIC_IMAGE: 'https://hub.rentrincloud.it/api/public/imguser/',

    //! ===================================== ASIA ENV  TEST =========================================================
    // production: false,
    // BASE_API_URL_WEBRIFIUTI: 'https://www.webrifiuti.it/api/',
    // BASE_API_URL_APIREST: 'www.rentri.website/apirest/',

    // SOCKET_ENDPOINT_RICICLATV: 'https://socket.hichat.it:8500/?token=',
    // SOCKET_TOKEN_RICICLATV: '',
    // BANNER_IMAGE_URL_RICICLATV: 'https://www.ricicla.tv/dev/laravel_app/storage/app/images/riciclatv/banner_bottom/',

    // SHOW_RENTRI: false,
    // BASE_API_URL: 'https://hub.asianapoli.it/test/api/',
    // BASE_URL_HELP: 'https://hub.asianapoli.it/dochelp/',
    // BASE_PUBLIC_IMAGE: "https://hub.asianapoli.it/test/api/public/imguser/",

    // EMAIL_AMMINISTRAZIONE: '',
    // LINK_HOME_PAGE: 'https://www.winwaste.net/ww',
    // VERSIONE: '0.0.0',
    // SWAGGER: 'https://test.rentrincloud.it/api/swagger/index.html',
    // END_POINT_AI: '',
    // END_POINT_DHWASTE: '',
    // END_POINT_VIVIFIR: '',
    // END_POINT_RENTRI: '',
    //! ===================================== ASIA ENV  PROD =========================================================
    // production: true,
    // BASE_API_URL_WEBRIFIUTI: 'https://www.webrifiuti.it/api/',
    // BASE_API_URL_APIREST: 'www.rentri.website/apirest/',

    // SOCKET_ENDPOINT_RICICLATV: 'https://socket.hichat.it:8500/?token=',
    // SOCKET_TOKEN_RICICLATV: '',
    // BANNER_IMAGE_URL_RICICLATV: 'https://www.ricicla.tv/dev/laravel_app/storage/app/images/riciclatv/banner_bottom/',

    // SHOW_RENTRI: false,
    // BASE_API_URL: 'https://hub.asianapoli.it/api/',
    // BASE_URL_HELP: 'https://hub.asianapoli.it/dochelp/',
    // BASE_PUBLIC_IMAGE: "https://hub.asianapoli.it/api/public/imguser/",
    // EMAIL_AMMINISTRAZIONE: '',
    // LINK_HOME_PAGE: 'https://www.winwaste.net/ww',
    // VERSIONE: '0.0.0',
    // SWAGGER: '',
    // END_POINT_AI: '',
    // END_POINT_DHWASTE: '',
    // END_POINT_VIVIFIR: '',
    // END_POINT_RENTRI: '',
};
